<template>
  <component :is="type"/>
</template>

<script>
import messenger from '@/assets/icons/channels/messenger.svg';
import sms from '@/assets/icons/channels/sms.svg';
import telegram from '@/assets/icons/channels/telegram.svg';
import webchat from '@/assets/icons/channels/webchat.svg';
import whatsapp from '@/assets/icons/channels/whatsapp.svg';

export default {
  components: {
    messenger,
    sms,
    telegram,
    webchat,
    whatsapp,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
};
</script>
